<template>
    <a-modal :visible="isModalOpen" @update:visible="val => isModalOpen = val" @ok="() => submit()"
        @cancel="closeModal" ok-text="Kirim" cancel-text="Batal" :confirm-loading="isSubmitting" class="modal-saran-masukan">
        <div class="w-full flex flex-col gap-2">
            <div class="w-full flex flex-col gap-px px-1">
                <h4 class="text-center! text-white text-xl!">Saran dan Masukan</h4>
                <p class="text-white text-xs! text-justify">Demi terus meningkatkan kualitas layanan dan memastikan pengalaman terbaik bagi seluruh pengguna, setiap masukan, saran, atau tanggapan sangat dihargai. Mohon luangkan waktu sejenak untuk menyampaikan pandangan, ide, atau rekomendasi melalui kolom yang telah disediakan. Kontribusi ini akan menjadi bahan evaluasi yang berharga untuk perbaikan dan pengembangan ke depan.</p>
                <b class="text-white text-xs!">Berikan saran atau masukan pada kolom dibawah ini:</b>
            </div>
            <div class="flex flex-col gap-1">
                <input type="text" id="name" name="name" placeholder="Nama Lengkap"
                    class="form-control w-full text-xs!" v-model="formRef.name" required />
            </div>
            <div class="flex flex-col gap-1">
                <input type="email" id="email" name="email" placeholder="Email"
                    class="form-control w-full text-xs!" v-model="formRef.email" required />
            </div>
            <textarea v-model="formRef.comment" id="saran" name="saran" class="form-control w-full text-xs!" placeholder="Uraian saran dan masukan" rows="3" required />
            <div class="mx-auto mt-2">
                <Recaptcha :siteKey="siteKey" @verified="onVerify" @expired="onExpired" />
            </div>
        </div>
    </a-modal>
</template>

<script>
import { Modal } from 'ant-design-vue';
import { ref } from 'vue';
import Swal from 'sweetalert2'
import Recaptcha from "@/component/utils/Recaptcha.vue";
import { router } from '@/router';
import { mapActions, mapState } from 'vuex';

export default {
    props: {
        isModalOpen: {
            type: Boolean,
            default: false,
        },
    },
    setup() {
        const formRef = ref({
            name: null,
            email: null,
            comment: null,
        });
        const saranRef = ref(null);
        const isSubmitting = ref(false)
        const state = ref({
            isVerified: false,
            token: null,
        })
        const siteKey = process.env.VUE_APP_SITE_KEY;

        return {
            formRef,
            saranRef,
            isSubmitting,
            state,
            siteKey,
        }
    },
    components: {
        AModal: Modal,
        Recaptcha,
    },
    methods: {
        ...mapActions('homePage', ['sendSaran', 'checkRecaptcha']),
        openModal() {
            this.$emit('onModalOpen')
        },
        async submit() {
            try {
                this.isSubmitting = true
                if (!this.formRef.name || !this.formRef.email) {
                    Swal.fire({
                        title: 'Error',
                        text: 'Kolom nama dan email harus diisi',
                        icon: 'error',
                    })
                    return
                }

                if (!this.formRef.comment) {
                    Swal.fire({
                        title: 'Error',
                        text: 'Kolom saran atau masukan harus diisi',
                        icon: 'error',
                    })
                    return
                }

                if (!this.state.token) {
                    Swal.fire({
                        title: 'Error',
                        text: 'Harap selesaikan recaptcha',
                        icon: 'error',
                    })
                    return
                }

                const captchaResponse = await this.checkRecaptcha({
                    token: this.state.token,
                });
                if (captchaResponse.valid) {
                    const res = await this.sendSaran(this.formRef)
                    if (res.success) {
                        Swal.fire({
                            title: 'Sukses',
                            text: res.message,
                            icon: 'success'
                        }).then(() => {
                            this.saranRef = null
                            this.closeModal()
                        })
                    } else {
                        if (window?.grecaptcha) {
                            window.grecaptcha.reset()
                        }
                    }

                }
            } catch (err) {
                if (err?.response?.status === 401) {
                    Swal.fire({
                        title: 'Error',
                        text: 'Terjadi kesalahan, silakan coba kembali',
                        icon: 'error'
                    }).then(() => {
                        // router.push('/auth/login')
                        this.closeModal()
                    })
                }

                if (err?.response?.data?.errors) {
                    const errorMessages = Object.values(err?.response?.data?.errors).join(', ')

                    Swal.fire({
                        title: 'Error',
                        text: errorMessages,
                        icon: 'error',
                    })
                }
            } finally {
                this.isSubmitting = false
                if (window?.grecaptcha) {
                    window.grecaptcha.reset()
                }
                this.state.token = null
                this.state.isVerified = false
            }
        },
        closeModal() {
            this.formRef.name = null;
            this.formRef.email = null;
            this.formRef.comment = null;
            this.saranRef = null
            this.$emit('onModalCloses')
        },
        onVerify(token) {
            this.state.isVerified = true;
            this.state.token = token;
        },
        onExpired() {
            this.state.isVerified = false;
            this.state.token = "";
        },
    },
    computed: {
        ...mapState('homePage', {
            dataUser: (state) => state.user,
        })
    },
    updated() {
        // if (!this.dataUser && this.isModalOpen) {
        //     Swal.fire({
        //         title: 'Anda harus login terlebih dahulu',
        //         icon: 'warning'
        //     }).then(() => {
        //         router.push('/auth/login')
        //         this.closeModal()
        //     })
        // }
    }
}
</script>

<style scoped>
.color-theme {
    background-color: #CAF0F8;
    color: #023e8a;
}
</style>